import { useEffect } from "react";

/* Global 3D tilt on .lux-card + magnetic pull on .foil-pill (desktop only) */
const InteractiveFX = () => {
  useEffect(() => {
    if (!window.matchMedia("(hover: hover) and (pointer: fine)").matches) return;
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

    let card = null;
    let pill = null;
    let raf = null;
    let mx = 0, my = 0;

    const apply = () => {
      raf = null;
      if (card) {
        const r = card.getBoundingClientRect();
        const px = (mx - r.left) / r.width - 0.5;
        const py = (my - r.top) / r.height - 0.5;
        card.style.transform = `perspective(1100px) rotateX(${(-py * 5).toFixed(2)}deg) rotateY(${(px * 5).toFixed(2)}deg) translateY(-2px)`;
      }
      if (pill) {
        const r = pill.getBoundingClientRect();
        const dx = mx - (r.left + r.width / 2);
        const dy = my - (r.top + r.height / 2);
        pill.style.transform = `translate(${(dx * 0.15).toFixed(1)}px, ${(dy * 0.25).toFixed(1)}px)`;
      }
    };

    const onMove = (e) => {
      mx = e.clientX;
      my = e.clientY;
      const c = e.target.closest && e.target.closest(".lux-card");
      const p = e.target.closest && e.target.closest(".foil-pill");
      if (c !== card) {
        if (card) card.style.transform = "";
        card = c;
        if (card) card.style.transition = "transform 0.18s ease-out";
      }
      if (p !== pill) {
        if (pill) pill.style.transform = "";
        pill = p;
        if (pill) pill.style.transition = "transform 0.22s cubic-bezier(0.22,1,0.36,1)";
      }
      if (!raf && (card || pill)) raf = requestAnimationFrame(apply);
    };

    const onLeave = () => {
      if (card) { card.style.transform = ""; card = null; }
      if (pill) { pill.style.transform = ""; pill = null; }
    };

    document.addEventListener("mousemove", onMove, { passive: true });
    document.addEventListener("mouseleave", onLeave);
    return () => {
      document.removeEventListener("mousemove", onMove);
      document.removeEventListener("mouseleave", onLeave);
      if (raf) cancelAnimationFrame(raf);
      onLeave();
    };
  }, []);
  return null;
};

export default InteractiveFX;
